import { type Data } from "@measured/puck";
import { ComponentRenderer } from "./ComponentRenderer";
import { lazy, useMemo } from "react";
import type { ContentComponentConfig, ContentRootProps } from "@op/puck-types";

const ContentRoot = lazy(() =>
  import("../components/puck/Root/ContentRoot").then((mod) => ({
    default: mod.default,
  }))
);

export interface ContentRendererProps {
  data: Data<ContentComponentConfig, ContentRootProps>;
}

export const ContentRenderer = ({ data }: ContentRendererProps) => {
  const rootProps = useMemo(() => data.root.props, [data.root.props]);
  const actualRootProps = useMemo(
    (): ContentRootProps => ({
      authors: rootProps?.authors ?? [],
      languageLinks: rootProps?.languageLinks ?? [],
      title: rootProps?.title ?? "",
      hero: rootProps?.hero,
      citation: rootProps?.citation,
      doi: rootProps?.doi,
      contact: rootProps?.contact,
      copyrightNote: rootProps?.copyrightNote,
      imageCredits: rootProps?.imageCredits,
    }),
    [rootProps]
  );

  return (
    <ContentRoot {...actualRootProps}>
      {data.content.map((node) => (
        <ComponentRenderer key={node.props.id} node={node} />
      ))}
    </ContentRoot>
  );
};
